import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.851 4.667h-2V4a2.667 2.667 0 0 0-5.333 0v.667h-2a.667.667 0 0 0-.667.666v7.334a2 2 0 0 0 2 2h6.667a2 2 0 0 0 2-2V5.333a.667.667 0 0 0-.667-.666m-6-.667a1.333 1.333 0 0 1 2.667 0v.667H6.85zm5.333 8.667a.667.667 0 0 1-.666.666H4.85a.667.667 0 0 1-.667-.666V6h1.334v.667a.667.667 0 0 0 1.333 0V6h2.667v.667a.667.667 0 0 0 1.333 0V6h1.333z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.191 11h10v1h-10z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })